// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6a743025","952":"9a3158ef"}[chunkId] + ".chunk.js";
};